import { CircularProgress, Grid, Typography } from "@material-ui/core";
import { useQuery } from "@tanstack/react-query";
import clsx from "clsx";
import { useSetAtom } from "jotai";
import { CourseActiveApi, CourseApi } from "../../models/api/course";
import { BaseLearningPathApi } from "../../models/api/learning-path";
import { getLearningPath } from "../../services";
import { useHistory } from "../../shared/hooks/useHistory";
import { CoursePathIcon } from "../../shared/icons";
import { currentGamePlanIndexAtom } from "../wizard/atoms";
import { COLORS, useStyles } from "./other-courses.styles";

type Props = {
  learningPathId: BaseLearningPathApi["id"];
  activeCourseId: CourseActiveApi["id"] | null;
};

export const OtherCourses = ({ learningPathId, activeCourseId }: Props) => {
  const classes = useStyles();
  const history = useHistory();
  const setCurrentGamePlanIndex = useSetAtom(currentGamePlanIndexAtom);

  const { data: learningPathData, isLoading } = useQuery({
    queryKey: ["assessments/learningpath", learningPathId],
    queryFn: () => getLearningPath(learningPathId),
  });

  if (isLoading) {
    return (
      <Grid className={classes.loading}>
        <CircularProgress />
      </Grid>
    );
  }

  const courses = learningPathData?.courses?.filter(
    (course, index) => course.id !== activeCourseId || index !== 0
  );

  if (!courses?.length) {
    return null;
  }

  const handleItemClick = (course: CourseApi) => async () => {
    setCurrentGamePlanIndex(-1);
    history.push(`/learningPath/${course.id}`);
  };

  return (
    <Grid container direction="column">
      <Grid
        item
        container
        justifyContent="space-between"
        className={classes.titleContainer}
      >
        <Typography className={classes.title} data-testid="title">
          Other Courses
        </Typography>
      </Grid>
      <Grid className={classes.courseOuterContainer}>
        {courses.map((course, index) => (
          <Grid
            key={course.id}
            className={clsx(
              classes.courseContainer,
              classes[`color${index % COLORS.length}`]
            )}
            onClick={handleItemClick(course)}
          >
            <Grid>
              <Typography variant="h3" className={classes.courseTitle}>
                {course.name}
              </Typography>
            </Grid>
            <Grid className={classes.modulesOuterContainer}>
              <CoursePathIcon />
            </Grid>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};
